module.exports = __webpack_public_path__ + "img/accountVideoDevice.be93f68a.jpg";